import React, {useState} from "react";

function ErrorPage(props){

    return <div id={'error-page'} className={'container vh-100 d-flex align-items-center justify-content-center'}>

        <div id="error-info">
            <h1>
                Error #404
            </h1>

            <p className={'lead text-muted'}>
                Сторінка не знайдена / Перевірте посилання
            </p>

            <a href="/" className={'btn btn-dark rounded-0'}>Home page</a>
        </div>

    </div>

}

export default ErrorPage;
